<template>
  <div id="personBar"></div>
</template>
<script>
export default {
  data() {
    return {
      persons: {
        xData: ["10-01", "10-02", "10-03", "10-04", "10-05", "10-06", "10-07"],
        yData: [12, 2, 5, 14, 7, 9, 7],
      },
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        sort: 1,
        startTime: "",
      },
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      this.getData();
      //this.drawBar(this.persons);
    },
    groups(v) {
      this.searchItem.groupIdList = [];
      for (let i = 0; i < v.length; i++) {
        this.searchItem.groupIdList.push(v[i].id);
      }
      this.getData();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-rmm-server-rpt/count/countDpOverview",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        this.persons.xData = [];
        this.persons.yData = data.totalList;
        for (let i = 0; i < data.dateList.length; i++) {
          var m = this.utils.time(data.dateList[i], "mmdd");
          this.persons.xData.push(m);
        }
        this.drawBar(this.persons);
      });
    },
    drawBar(obj) {
      this.chart = this.echarts.init(
        document.getElementById("personBar"),
        "dark"
      );
      this.option = {
        backgroundColor: "",
        grid: {
          x: 30,
          y: 20,
          x2: 30,
          y2: 80, //距离下边的距离
        },
        dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ],
        xAxis: {
          type: "category",
          data: obj.xData,
          axisLabel: { rotate: 45 },
        },
        yAxis: {
          type: "value",
        },
        color: "#59ddfe",
        series: [
          {
            data: obj.yData,
            type: "line",
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {
              //color: "#ff7c25",
              opacity: "0.9",
              //shadowColor: "#000",
              // shadowBlur: 50,
              //shadowOffsetX:0,
              // shadowOffsetY:-10
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#2c94e5",
                },
                {
                  offset: 1,
                  color: "#132230",
                },
              ]),
            },
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name + "：" + val.value + "次";
          },
        },
      };
      this.chart.setOption(this.option);
    },
  },
  mounted() {},
};
</script>
<style lang="">
#personBar {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/paigongzonglan.vue